import { Box, Modal, Typography } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Close from "@mui/icons-material/Close";
import { alpha, useTheme } from "@mui/material/styles";
import { IconButton } from "@itk/mui-components";
import { GalleryModalProps } from "./image-gallery-modal-types";
import { useEffect } from "react";
import { genericTranslationsK } from "src/translation-hooks/generic-translations";

export const ImageGalleryModal = ({ open, images, currentIndex, setOpen, setCurrentIndex }: GalleryModalProps) => {
  const theme = useTheme();

  const handleClose = () => setOpen(false);
  const handleNext = () => setCurrentIndex && setCurrentIndex(prev => (prev + 1) % images.length);
  const handlePrev = () => setCurrentIndex && setCurrentIndex(prev => (prev - 1 + images.length) % images.length);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!open) return;
      if (event.key === "ArrowRight") handleNext();
      else if (event.key === "ArrowLeft") handlePrev();
    };
    document.addEventListener("keydown", handleKeyDown);

    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: alpha(theme.palette.customColors.black, 0.5)
      }}
    >
      <Box
        sx={{
          py: 10,
          position: "relative",
          width: "100%",
          height: "100%",
          outline: 0,
          mx: 2
        }}
      >
        {setCurrentIndex && (
          <IconButton
            k={genericTranslationsK.back}
            onClick={handlePrev}
            sx={{
              borderRadius: 1,
              backgroundColor: theme.palette.primary.main,
              position: "absolute",
              left: 10,
              top: "50%",
              transform: "translateY(-50%)",
              "&:hover": {
                backgroundColor: theme.palette.primary.main
              }
            }}
          >
            <ArrowBackIosNewIcon sx={{ color: theme.palette.customColors.white }} />
          </IconButton>
        )}

        {images?.[currentIndex] && <img src={images[currentIndex]} alt="Gallery" width="100%" height="100%" style={{ objectFit: "contain" }} />}

        {setCurrentIndex && (
          <IconButton
            k={genericTranslationsK.next}
            onClick={handleNext}
            sx={{
              borderRadius: 1,
              backgroundColor: theme.palette.primary.main,
              position: "absolute",
              right: 10,
              top: "50%",
              transform: "translateY(-50%)",
              "&:hover": {
                backgroundColor: theme.palette.primary.main
              }
            }}
          >
            <ArrowForwardIosIcon sx={{ color: theme.palette.customColors.white }} />
          </IconButton>
        )}

        <IconButton
          k={genericTranslationsK.close}
          onClick={handleClose}
          sx={{
            color: theme.palette.customColors.white,
            position: "absolute",
            top: 10,
            right: 10
          }}
        >
          <Close />
        </IconButton>
        {images.length > 1 && (
          <Typography
            variant="body2"
            sx={{
              color: theme.palette.customColors.white,
              position: "absolute",
              bottom: 35,
              right: 267,
              fontWeight: theme.typography.fontWeightMedium
            }}
          >
            {`${String(currentIndex + 1).padStart(2, "0")} / ${String(images.length).padStart(2, "0")}`}
          </Typography>
        )}
      </Box>
    </Modal>
  );
};
